import { Button } from "#components/Button.tsx";
import SpinningLogo from "#components/design/SpinningLogo.tsx";
import { TermlyPolicy, useTermly } from "./termly.tsx";

export default function LegalPolicy({ id }: { id: string }) {
	useTermly();
	return (
		<>
			<div className="flex flex-col items-center gap-4">
				<SpinningLogo
					variant="orange"
					className="mt-24 mx-auto max-w-[175px]"
				/>
				<Button className="max-w-lg mx-auto" href="/">
					&larr; Return To Site
				</Button>
			</div>
			<TermlyPolicy id={id} />
		</>
	);
}
